var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"dialog-fade","appear":""}},[_c('div',{staticClass:"dialog-mask",on:{"click":_vm.onMaskClick}},[_c('div',{staticClass:"dialog-panel",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }